export default __webpack_public_path__ + "static/media/bs1.1.34464e1d.png";